import { bindable, transient, containerless } from "aurelia-framework";

@transient()
@containerless
export class Panel {
    @bindable public class: string = "";
    @bindable public title: string = "";
}
